/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeraboutadd2Inputs */

const en_organizeraboutadd2 = /** @type {(inputs: Organizeraboutadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a text`)
};

const de_organizeraboutadd2 = /** @type {(inputs: Organizeraboutadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text schreiben`)
};

/**
* | output |
* | --- |
* | "Write a text" |
*
* @param {Organizeraboutadd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeraboutadd2 = /** @type {((inputs?: Organizeraboutadd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeraboutadd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeraboutadd2(inputs)
	return de_organizeraboutadd2(inputs)
});
export { organizeraboutadd2 as "organizerAboutAdd" }